<ng-container *ngIf="type !== 'bullet'; else bulletRadio">
  <mat-checkbox
    [class]="'base__container-checkbox munily-checkbox munily-checkbox--type-' + type + ' ' + customClass"
    [id]="id"
    [name]="name"
    [checked]="value"
    [disabled]="disabled"
    [labelPosition]="labelPosition"
    [required]="required"
    [indeterminate]="indeterminate"
    (change)="onCheckboxChange($event)"
  >
    <span *ngIf="labelKey">{{ labelKey | translate: (labelParams || {}) }}</span>
  </mat-checkbox>
</ng-container>

<ng-template #bulletRadio>
  <mat-radio-group
    class="base__container-checkbox munily-bullet-radio"
    [class.munily-bullet-radio--label-before]="labelPosition === 'before'"
    [class.munily-bullet-radio--label-after]="labelPosition === 'after'"
    [ngClass]="customClass"
    [attr.id]="id"
    [attr.aria-label]="name || id || 'bullet-radio'"
    [disabled]="!!disabled"
  >
    <mat-radio-button
      class="munily-bullet-radio__button"
      [checked]="value"
      [value]="true"
      (click)="onBulletClickToggle($event)"
      (change)="onBulletRadioChange($event.value)"
    >
      <span *ngIf="labelKey">{{ labelKey | translate: (labelParams || {}) }}</span>
    </mat-radio-button>
  </mat-radio-group>
</ng-template>